import { _ } from "../../core/polyglot/polyglot.js";
import accountingDocument from "./accountingDocument.js";
import OldSpinnerWidget from "../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner
import stacker from "../../core/elements/stacker/stacker.js";

/**
 * A document that is rendered in a separate window. By default it
 * doesn't render the application header nor navigation.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 */
function windowedDocument(spec, my) {
	spec ||= {};
	my ||= {};

	const that = accountingDocument(spec, my);

	// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
	my.spinner = new OldSpinnerWidget({
		size: 68,
	});

	that.hasNavigation = function () {
		return false;
	};

	that.hasActionsMenu = function () {
		return false;
	};

	that.documentId = "windowed";

	that.renderTopActionsOn = function (html) {
		if (my.router.isHistoryEmpty()) {
			html.button(
				{
					class: "btn btn-navbar pull-right",
					click: () => window.close(),
				},
				_("Close"),
			);
		} else {
			html.render(
				stacker(
					html.button(
						{
							class: "btn btn-navbar",
							click: () => window.close(),
						},
						_("Close"),
					),
					html.button(
						{
							class: "btn btn-navbar",
							click: () => my.router.back(),
						},
						_("Back"),
					),
				),
			);
		}
	};

	return that;
}

export default windowedDocument;
